module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sailing_e750c6.jpg";